// full video control set will go here eventually
// for now, just make sure playback stops when the dialog is closed

var videoDialog;
var videoPlayer;

document.addEventListener("DOMContentLoaded", (event) => {
    videoDialog = document.getElementById("video-dialog");
    videoPlayer = document.getElementById("video-player");

    videoDialog.addEventListener("close", (e) => {
        videoPlayer.pause();
    });
    
});

